export const sumBy = (propName: string, items: any[]) =>
  items.reduce((total: number, item: any) => total + (Number(item[propName]) || 0), 0);
